<template>
  <!-- 安全设置 -->
  <div>
    <h3>{{ $t('myAccount.menu[1]') }}</h3>
    <!-- 当前账户安全程度 -->
    <a-row type="flex" align="middle">
      <a-col>{{ $t('myAccount.curAccount') }}</a-col>
      <a-col>
        <div class="progress" v-if="secInfo.percent == 100"><a-progress strokeColor="#1890ff" :strokeWidth="20" :percent="secInfo.percent" size="small" :showInfo="false"/></div>
        <div class="progress" v-else><a-progress strokeColor="#F8B551" :strokeWidth="20" :percent="secInfo.percent" size="small" :showInfo="false"/></div>
      </a-col>
      <a-col>
        <span>{{ $t('myAccount.securityLevel') }}：</span>
        <span v-if="secInfo.percent < 50">{{ $t('myAccount.levelList[0]') }}</span>
        <span v-else-if="secInfo.percent == 50">{{ $t('myAccount.levelList[1]') }}</span>
        <span v-else>{{ $t('myAccount.levelList[2]') }}</span>
        <span v-if="secInfo.percent < 100"> {{ $t('myAccount.continue') }}</span>
      </a-col>
    </a-row>
    <!-- 登录密码 -->
    <a-row type="flex" justify="space-around" class="sec_item">
      <a-col :span="3" class="sec_title">{{ $t('myAccount.securType[0]') }}</a-col>
      <a-col :span="17">
        <span>{{ $t('myAccount.tipPwd') }}</span>
      </a-col>
      <!-- 已设置 -->
      <a-col :span="4" class="sec_btn">
        <span class="bold_color"><b-icon type="iconwanchengrenwu"></b-icon>{{ $t('myAccount.securState[0]') }}</span>
        <a-divider type="vertical" />
        <span class="bule_color" @click="toUpdate(1)">{{ $t('myAccount.securState[1]') }}</span>
      </a-col>
    </a-row>
    <!-- 手机绑定 -->
    <a-row type="flex" justify="space-around" class="sec_item">
      <a-col :span="3" class="sec_title">{{ $t('myAccount.securType[1]') }}</a-col>
      <a-col :span="17">
        <div v-if="secInfo.phone">
          <span>{{ $t('myAccount.bindPhone') }}</span>
          <span class="bold_color">{{ secInfo.phone.substring(0, 3) }}****{{ secInfo.phone.substring(secInfo.phone.length - 4) }}</span>
          <span>[{{ $t('myAccount.phone') }}]</span>
        </div>
      </a-col>
      <!-- 已设置 -->
      <a-col :span="4" class="sec_btn" v-if="secInfo.phone">
        <span class="bold_color"><b-icon type="iconwanchengrenwu"></b-icon>{{ $t('myAccount.securState[0]') }}</span>
        <a-divider type="vertical" />
        <span class="bule_color" @click="toUpdate(2)">{{ $t('myAccount.securState[1]') }}</span>
      </a-col>
      <!-- 未绑定 -->
      <a-col :span="4" class="sec_btn" v-else>
        <span class="red_color"><b-icon type="iconweibangding1"></b-icon>{{ $t('myAccount.securState[4]') }}</span>
        <a-divider type="vertical" />
        <span class="bule_color" @click="toUpdate(2)">{{ $t('myAccount.securState[5]') }}</span>
      </a-col>
    </a-row>
    <!-- 邮箱绑定 -->
    <a-row type="flex" justify="space-around" class="sec_item">
      <a-col :span="3" class="sec_title">{{ $t('myAccount.securType[2]') }}</a-col>
      <a-col :span="17">
        <span v-if="secInfo.email">{{ $t('myAccount.bindEmail') }} <span class="bold_color">{{ secInfo.email.substring(0,3) }}****{{ secInfo.email.split('@')[1] }}</span></span>
      </a-col>
      <!-- 已设置 -->
      <a-col :span="4" class="sec_btn" v-if="secInfo.email">
        <span class="bold_color"><b-icon type="iconwanchengrenwu"></b-icon>{{ $t('myAccount.securState[0]') }}</span>
        <a-divider type="vertical" />
        <span class="bule_color" @click="toUpdate(3)">{{ $t('myAccount.securState[1]') }}</span>
      </a-col>
      <!-- 未绑定 -->
      <a-col :span="4" class="sec_btn" v-else>
        <span class="red_color"><b-icon type="iconweibangding1"></b-icon>{{ $t('myAccount.securState[4]') }}</span>
        <a-divider type="vertical" />
        <span class="bule_color" @click="toUpdate(3)">{{ $t('myAccount.securState[5]') }}</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AES from '@/utils/aes'

export default {
  computed: {
    ...mapGetters(['userInfo']),
    secInfo () {
      const info = JSON.parse(this.userInfo || '{}')
      // 判断密码强度 设置密码：25（低），设置密码并且设置邮箱或者手机号：50（中），全设置了：100（高）
      let strength = 25
      if (info.custMail && info.custPhone) {
        strength = 100
      } else {
        strength = 50
      }
      const obj = {
        phone: info.custPhone,
        email: info.custMail,
        percent: strength
      }
      return obj
    }
  },
  methods: {
    /**
     * 修改
     */
    toUpdate (type) {
      window.open(`${this.$config.baseOAuthUrl}user/account?token=${AES.Decrypt(this.$cookies.get('access_token'))}&type=${type}&lang=${this.$i18n.locale.replace('-', '_')}`)
    }
  }
}
</script>

<style lang="less" scoped>
h3 {
  font-weight: bold;
  padding: 10px 0;
  margin-bottom: 20px;
}
.progress {
  width:200px;
  margin: 0 20px;
}
.sec_item {
  border-bottom: 1px solid #eee;
  padding: 25px 0;
  .sec_title {
    font-weight: bold;
  }
  .bule_color {
    color: #4977FC;
    cursor: pointer;
  }
  .bold_color {
    color: #52C41A;
  }
  .red_color {
    color: #F5222D;
  }
  .sec_btn {
    text-align: right;
  }
}
</style>
